import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { rollupSyncActionState } from '@shared/store/sync/utils/rollup-sync-action-state';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiProgress } from '@taiga-ui/kit';
import { SyncActionChildKey } from './models/sync-action-child-key';
import { SyncActionDisplay } from './models/sync-action-display';
import { SyncCenterItemComponent } from './sync-center-item/sync-center-item.component';
import { SyncCenterStateService } from './sync-center-state.service';

@Component({
  selector: 'pxc-sync-center',
  templateUrl: './sync-center.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiButton, TuiHint, TuiProgress, TranslocoDirective, SyncCenterItemComponent, EmptyStateComponent],
  host: {
    class: 'bg-background-primary flex flex-col rounded-lg shadow-md min-w-96 max-w-sm',
  },
})
export class SyncCenterComponent {
  protected readonly syncCenterState = inject(SyncCenterStateService);
  readonly title = input.required<string>();
  readonly items = input<SyncActionDisplay[]>([]);
  readonly resumeChild = output<SyncActionChildKey>();
  readonly retryChild = output<SyncActionChildKey>();
  readonly deleteChild = output<SyncActionChildKey>();

  protected readonly globalProgress = computed(
    () => rollupSyncActionState(this.items().map((item) => item.state)).progress,
  );
}
